/**
 * Created by ren on 01/06/2017.
 */
export const ACCESS_LOG                 = 'access_log';
export const ADDRESS_TYPE               = 'address_type';
export const ATTRIBUTE_NAME             = 'attribute_name';
export const ATTRIBUTE_VALUE            = 'attribute_value';
export const BRAND                      = 'brand';
export const CASH_ROUNDING              = 'cash_rounding';
export const CHANGE_AUDIT               = 'change_audit_log';
export const CHANGE_AUDIT_LOG_FIELD     = 'change_audit_log_field';
export const CLASSIFICATION             = 'classification';
export const COUNTRY                    = 'country';
export const CREDIT_CERTIFICATE         = 'credit_certificate';
export const CREDIT_TYPE                = 'credit_type';
export const CSV_EXPORT                 = 'csv_export';
export const CSV_RECORD                 = 'csv_record';
export const CSV_STATUS                 = 'csv_status';
export const CURRENCY                   = 'currency';
export const CUSTOM_FIELD               = 'custom_field';
export const CUSTOM_FORM                = 'custom_form';
export const CUSTOM_TAB                 = 'custom_tab';
export const DASHBOARD                  = 'dashboard';
export const DELIVERY_TYPE              = 'delivery_type';
export const DEVICE                     = 'device';
export const DEVICE_STATUS              = 'device_status';
export const DEVICE_TYPE                = 'device_type';
export const ENTITY                     = 'entity';
export const ENTITY_TYPE                = 'entity_type';
export const EVENT                      = 'event';
export const EXCHANGE_RATE              = 'exchange_rate';
export const FACET                      = 'facet';
export const FEATURE                    = 'feature';
export const GROUP_TYPE                 = 'group_type';
export const HOTKEY_GROUP               = 'hotkey_group';
export const HOTKEY_GROUP_ITEM          = 'hotkey_group_item';
export const HOTKEY_TEMPLATE            = 'hotkey_template';
export const INTEGRATION                = 'integration';
export const INVENTORY_ADJUSTMENT       = 'inventory_adjustment';
export const INVENTORY_MOVEMENT         = 'inventory_movement';
export const INVENTORY_MOVEMENT_CONTROL = 'inventory_movement_control';
export const INVENTORY_RETURN           = 'inventory_return';
export const INVENTORY_STATUS           = 'inventory_status';
export const INVENTORY_TRANSFER         = 'inventory_transfer';
export const ITEM                       = 'item';
export const ITEM_GROUP_PRICE           = 'item_group_price';
export const ITEM_LOCATION              = 'item_location';
export const ITEM_MATRIX_ATTRIBUTE      = 'item_matrix_attribute';
export const ITEM_NUMBER_TYPE           = 'item_number_type';
export const ITEMTYPE                   = 'itemType';
export const JOB                        = 'job';
export const LABEL_PRINT                = 'label_print';
export const LANGUAGE                   = 'language';
export const LIST                       = 'list';
export const LOCATION                   = 'location';
export const LOYALTY                    = 'loyalty';
export const LOYALTY_REDEMPTION         = 'loyalty_redemption';
export const MATRIX_ATTRIBUTE           = 'matrix_attribute';
export const OAUTH2_CLIENT              = 'oauth2_client';
export const ORDER_GROUP                = 'order_group';
export const ORDER_MANAGEMENT           = 'order_management';
export const PAYMENT                    = 'payment';
export const PAYMENT_TYPE               = 'payment_type';
export const PREFERENCE                 = 'preference';
export const PRICE_GROUP                = 'price_group';
export const PRICE_LEVEL                = 'price_level';
export const PRICEBOOK                  = 'price_book';
export const PRINT_TEMPLATE             = 'print_template';
export const PROMOTION                  = 'promotion';
export const PURCHASE_ORDER             = 'purchase_order';
export const PURCHASE_RECEIPT           = 'purchase_receipt';
export const REASON_CODE                = 'reason_code';
export const REFERENCE_ID               = 'reference_id';
export const REGION                     = 'region';
export const RELATED_ENTITY_TYPE        = 'related_entity_type';
export const REPORT                     = 'report';
export const REPORTING_EXCHANGE_RATE    = 'reporting_exchange_rate';
export const ROLES                      = 'role';
export const SALE_TRANSACTION           = 'sale_transaction';
export const SALE_TRANSACTION_ITEM_LINE = 'sale_transaction_item_line';
export const SEASON                     = 'season';
export const SHIFT_TYPE                 = 'shift_type';
export const SHIPPING_METHOD            = 'shipping_method';
export const SUBSIDIARY                 = 'subsidiary';
export const TASK                       = 'task';
export const TASK_TYPE                  = 'task_type';
export const TAX_CODE                   = 'tax_code';
export const TAX_EXEMPT_TYPE            = 'tax_exempt_type';
export const TAX_GROUP                  = 'tax_group';
export const TAX_TYPE                   = 'tax_type';
export const TILL_MOVEMENT              = 'till_movement';
export const TRANSACTION_STATUS         = 'transaction_status';
export const UNIT_OF_MEASURE_TYPE       = 'unit_of_measure_type';
export const VOID_AUDIT                 = 'void_audit';
